import React, { useContext } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Text } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import getStaticImageUrl from '../../../utils/getStaticImageUrl';

import QuoteImage from '../../../../images/bundle-page/quote-free-image.jpg';
import Classes from './BundleQuote.module.scss';

const BundleQuote = () => {
  const i18n = useI18nContext();
  const { staticBaseUrl } = useContext(EnvironmentContext);

  return (
    <div className={Classes.root}>
      <h2 className={Classes.text}>{i18n.t('landingFreeBundle.quote.content')}</h2>
      <p>
        <img src={getStaticImageUrl(staticBaseUrl, QuoteImage)} className={Classes.image} alt="" />
      </p>
      <Text.Large as="p" className={Classes.name}>
        {i18n.t('landingFreeBundle.quote.name')}
      </Text.Large>
      <Text.Large as="p">{i18n.t('landingFreeBundle.quote.profession')}</Text.Large>
    </div>
  );
};

export default BundleQuote;
